export const sanitizeString = str => {
  const decodedStr = decodeURIComponent(str);
  return decodedStr.replace(/<[^>]+>/ig,"");
};